import React, { useState, useContext, useEffect } from "react";
import logo from '../assets/images/hey-visuals-logo.png';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import GoogleSignInPage from './GoogleSignIn';
import { LoadingContext } from './LoadinContext';
import '../assets/css/style.bundle.css';
import Swal from 'sweetalert2';

const decodeBase64 = (encodedStr) => {
  return decodeURIComponent(escape(atob(encodedStr)));
};
const decryptId = (encodedId) => {
  return JSON.parse(decodeBase64(encodedId));
};


const RegisterPage = () => {

  const { loadingGoogle } = useContext(LoadingContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone_number: "",
    password: "",
    confirm_password: "",
    toc: false,
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.name) newErrors.name = "Name is required.";
    if (!formValues.email) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formValues.email)) newErrors.email = "Email is invalid.";
    if (!formValues.password) newErrors.password = "Password is required.";
    if (formValues.password !== formValues.confirm_password)
      newErrors.confirm_password = "Passwords do not match.";
    if (!formValues.confirm_password) newErrors.confirm_password = "confirm password is required.";
    if (!formValues.toc) newErrors.toc = "You must accept the terms.";
    setLoading(false);
    return newErrors;

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      try {
        const url = `${process.env.REACT_APP_BASE_URL}/email/verify/confirm`;
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formValues,
            app_url: url,
          }),
        });
        const data = await response.json();

        if (response.ok) {
          setLoading(false);
          if (data.status === 200) {
            localStorage.setItem('auth', JSON.stringify(data.user));
            navigate('/');
          } else if (data.status === 422) {
            setErrors(prevErrors => ({
              ...prevErrors,
              email: data.message.email ? data.message.email[0] : '',
              name: data.message.name ? data.message.name[0] : '',
              password: data.message.password ? data.message.password[0] : '',
              phone_number: data.message.phone_number ? data.message.phone_number[0] : '',
              confirm_password: data.message.confirm_password ? data.message.confirm_password[0] : '',
            }));
          }
        } else {
          console.log("Registration failed", data);
        }
      } catch (error) {
        console.error("Error during registration:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRe, setShowPasswordRe] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibilityRe = () => {
    setShowPasswordRe(!showPasswordRe);
  };

  const handleInputChangephone = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    let formattedInput = "";
    if (input.length > 0) formattedInput = `(${input.slice(0, 3)}`;
    if (input.length > 3) formattedInput += `) ${input.slice(3, 6)}`;
    if (input.length > 6) formattedInput += `-${input.slice(6, 10)}`;
    setFormValues({ ...formValues, phone_number: formattedInput });
  };

  const isFormValid = () => {
    const { name, email, password, confirm_password, toc } = formValues;
    return (
      name.trim() &&
      email.trim() &&
      password.trim() &&
      confirm_password.trim() &&
      // password === confirm_password && 
      toc
    );
  };


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [alreadyHaveAccount, setAlreadyHaveAccount] = useState(true);

  const toggleAccountCheckbox = () => {
    setAlreadyHaveAccount(false);
  };

  const toggleAccountCheckbox2 = () => {
    setAlreadyHaveAccount(true);
  };

  const encryptedDetails = searchParams.get('checkout');
  const details = encryptedDetails ? decryptId(encryptedDetails) : null;
  const validateForm2 = () => {
    const newErrors = {};
    setLoading(true);
    if (alreadyHaveAccount) {
      if (!formValues.email) {
        newErrors.email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
        newErrors.email = "Email is invalid.";
      }
    } else {
      if (!formValues.name) newErrors.name = "Name is required.";
      if (!formValues.email) {
        newErrors.email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
        newErrors.email = "Email is invalid.";
      }
      if (!formValues.password) newErrors.password = "Password is required.";
      if (formValues.password !== formValues.confirm_password)
        newErrors.confirm_password = "Passwords do not match.";
      if (!formValues.confirm_password)
        newErrors.confirm_password = "Confirm password is required.";
      if (!formValues.toc) newErrors.toc = "You must accept the terms.";
    }
    setLoading(false);
    return newErrors;
  };
  const isFormValid2 = () => {
    const newErrors = validateForm2();
    return Object.keys(newErrors).length === 0;
  };

  const handleClickPlans = async (e) => {
    setLoading(true);
    e.preventDefault();
    const allDetail = details;
    setLoading(true);
    const formErrors = validateForm2();
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      try {
        setLoading(true);
        const url = `${process.env.REACT_APP_BASE_URL}/email/verify/confirm`;
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formValues,
            app_url: url,
            sale: 'true',
            sale_acct_exist: alreadyHaveAccount,
          }),
        });
        const data = await response.json();
        if (response.ok) {
          if (data.status === 200) {
            try {
              setLoading(true);
              const authData = localStorage.getItem("auth");
              const token = authData ? JSON.parse(authData).token : null;

              const body = {
                _token: token,
                free_trail: 'false',
                app_url: `${process.env.REACT_APP_BASE_URL}/plans`,
                plan_id: allDetail.id,
                user_id: '',
                lang: "en",
                guest: 'true',
                rurl: url,
                name: formValues.name,
                email: formValues.email,
                phone_number: formValues.phone_number || "",
                password: formValues.password,
                confirm_password: formValues.confirm_password,
                toc: formValues.toc ? 1 : 0,
                sale: 'true',
                sale_acct_exist: alreadyHaveAccount,
                role_id: 2,
                timezone: formValues.timezone,
                country_code: formValues.country_code,
                user_name: formValues.user_name,
                plan_id: allDetail.id,

              };
              const NDody = { ...body, sData: { ...body } };
              const response = await fetch(`${process.env.REACT_APP_API_URL}/api/subscriptions/checkout`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(NDody),
              });

              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }

              let data;
              try {
                data = await response.json();
              } catch (jsonError) {
                throw new Error("Failed to parse JSON response");
              }
              if (data.status === 200) {
                window.location.href = data.checkout.url;
              } else if (data.status === 422) {
                Swal.fire({
                  text: `${data.message} Please contact the Admin!`,
                  icon: 'error',
                  title: 'Error!',
                  confirmButtonText: 'Ok'
                });
              } else if (data.status === 401) {
                navigate('/login');
              }
            } catch (error) {
              console.error("Error during subscription checkout:", error.message || error);
            } finally {
              setLoading(false);
            }
            // navigate('/');
          } else if (data.status === 422) {
            setErrors(prevErrors => ({
              ...prevErrors,
              email: data.message.email ? data.message.email : '',
              name: data.message.name ? data.message.name[0] : '',
              phone_number: data.message.phone_number ? data.message.phone_number[0] : '',
              password: data.message.password ? data.message.password[0] : '',
              confirm_password: data.message.confirm_password ? data.message.confirm_password[0] : '',
            }));
          } else if (data.status === 401) {
            navigate('/login');
          }
        } else {
          console.log("Registration failed", data);
        }
      } catch (error) {
        console.error("Error during registration:", error);
      } finally {
        setLoading(false);
      }
    }
    setLoading(false)
  };

  return (
    <>
      {details ? (
        <>
          <div className="d-flex flex-column flex-lg-row flex-column-fluid" style={{ backgroundColor: '#F7F8FB' }}>
            {/* Left Column */}
            <div className="d-flex flex-lg-row-fluid">
              <div className="d-none d-md-flex flex-column flex-center pb-0 w-100">
                <img className="theme-light-show w-250px mx-auto pb-10" src={logo} alt="Logo" />
                <section className="HomeVideoSection">
                  <div className="HomeVideoOuter">
                    <div className="video-wrapper">
                      <div className="wistia_responsive_padding" style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                        <div className="wistia_responsive_wrapper" style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
                          <iframe
                            src="https://fast.wistia.net/embed/iframe/dajig0c7nu?seo=true&videoFoam=true"
                            title="How Hey Visuals AI Works? Video"
                            allow="autoplay; fullscreen"
                            frameBorder="0"
                            scrolling="no"
                            className="wistia_embed"
                            name="wistia_embed"
                            style={{ width: '100%', height: '100%' }}
                          ></iframe>
                        </div>
                      </div>
                      <script src="https://fast.wistia.net/assets/external/E-v1.js" type="application/javascript" async></script>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* Right Section */}
            <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-md-12 p-10">
              <div className="bg-body-md d-flex flex-column flex-center rounded-4 w-md-600px p-md-10">
                <div className="card shadow p-3 mt-3 mb-5 bg-body rounded">
                  <div className="card-body">
                    <div className="text-center mb-3">
                      <h1 className="text-dark fw-bolder plan-nature">{details.plan} </h1>
                      <div className="fw-bold text-muted">
                      </div>
                      <div className="text-center fw-bold text-primary">{details.description} <br /><br /></div>
                      <div className="text-center">
                        <strike className="mb-2 fs-2 text-muted fw-bold">{details.originalPrice} </strike>
                        <span className="fs-6 text-muted " style={{ textDecoration: 'line-through' }}>{details.originalTimeperiod}</span><br />
                        {/* <span className="mb-2 fs-2x text-primary">$</span> */}
                        <span className="fs-3x fw-bold text-primary">{details.discountedPrice}</span>
                        <span className="fs-7 fw-semibold opacity-50"><span data-kt-element="period">{details.discountedTimeperiod}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="bg-body-sm d-flex flex-center flex-column align-items-stretch rounded-4 h-lg-100 w-md-400px p-md-0 p-7">
                  <div className="d-flex flex-center flex-column flex-column-fluid">
                    <img className="d-md-none d-lg-none d-xl-none theme-light-show mb-3 w-75" src={logo} alt="Mobile Logo" />
                    {/* Form Section */}
                    <div className="chooseways toggle-tabs mb-11 w-100">
                      <ul id="myTab" role="tablist" className="nav nav-tabs w-100">
                        <li role="presentation" className="nav-item w-50">
                          <button
                            id="texts-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#texts-tab-pane"
                            type="button"
                            role="tab"
                            aria-controls="texts-tab-pane"
                            aria-selected={alreadyHaveAccount ? "true" : "false"}
                            onClick={toggleAccountCheckbox2}
                            className={`nav-link w-100 rounded-3 ${alreadyHaveAccount ? "active" : ""}`}
                          >
                            Sign In
                          </button>
                        </li>
                        <li role="presentation" className="nav-item w-50">
                          <button
                            id="profile-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#profile-tab-pane"
                            type="button"
                            role="tab"
                            aria-controls="profile-tab-pane"
                            aria-selected={!alreadyHaveAccount ? "true" : "false"}
                            onClick={toggleAccountCheckbox}
                            className={`nav-link w-100 rounded-3 ${!alreadyHaveAccount ? "active" : ""}`}
                          >
                            Sign Up
                          </button>
                        </li>
                      </ul>
                    </div>

                    <form method="POST" className="form w-100" id="register-form" noValidate
                    // onSubmit={handleClickPlans}
                    >
                      <div className="text-center mb-11">
                        <h1 className="text-dark fw-bolder mb-3">{alreadyHaveAccount ? "Sign In" : "Sign Up"}</h1>
                        <div className="text-gray-500 fw-semibold fs-6 text-muted">
                          Your Social Campaigns
                        </div>
                      </div>

                      {/* Name input   */}
                      <div className="fv-row mb-8" style={{ display: alreadyHaveAccount ? 'none' : 'block' }}>
                        <input type="text" placeholder="Name" name="name" value={formValues.name} onChange={handleInputChange} className={`form-control bg-transparent register-name-inp ${errors.name ? 'is-invalid' : ''}`} />
                        {errors.name && <div className="text-danger">{errors.name}</div>}
                      </div>

                      {/* email  */}
                      <div className="fv-row mb-8">
                        <input type="email" placeholder="Email" name="email" value={formValues.email} onChange={handleInputChange} className={`form-control bg-transparent register-email-inp ${errors.email ? 'is-invalid' : ''}`} />
                        {errors.email && <div className="text-danger">{errors.email}</div>}
                      </div>

                      {/* Phone number input   */}
                      <div className="fv-row mb-8" style={{ display: alreadyHaveAccount ? 'none' : 'block' }}>
                        <input
                          type="text"
                          placeholder="Phone (Optional)"
                          autoComplete="off"
                          name="phone_number"
                          value={formValues.phone_number}
                          onChange={handleInputChangephone}
                          className={`form-control bg-transparent register-phone_number-inp ${errors.phone_number ? 'is-invalid' : ''}`}
                          maxLength="14"
                        />
                        <span className="col-md-12">
                          <em>eg:- (xxx) xxx-xxxx</em>
                        </span>
                        {errors.phone_number && <div className="text-danger">{errors.phone_number}</div>}
                      </div>

                      {/* Password input   */}
                      <div className="fv-row mb-8" data-kt-password-meter="true" style={{ position: 'relative', display: alreadyHaveAccount ? 'none' : 'block' }}>
                        <input type={showPassword ? 'text' : 'password'} placeholder="Password" name="password" value={formValues.password} onChange={handleInputChange} className={`form-control bg-transparent register-password-inp ${errors.password ? 'is-invalid' : ''}`} />
                        <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                          <i className={`bi bi-eye-slash fs-4 text-muted ${showPassword ? 'd-none' : ''}`}
                            onClick={togglePasswordVisibility}
                          ></i>
                          <i className={`bi bi-eye fs-4  text-primary ${showPassword ? '' : 'd-none'}`}
                            onClick={togglePasswordVisibility}
                          ></i>
                        </div>

                        {errors.password && <div className="text-danger">{errors.password}</div>}
                        <p className="text-muted">Use 8 or more characters with a mix of letters, at least one capital letter, one number, and one special character.</p>
                      </div>

                      {/* Password Confirm input   */}
                      <div className="fv-row mb-8" style={{ position: 'relative', display: alreadyHaveAccount ? 'none' : 'block' }}>
                        <input type={showPasswordRe ? 'text' : 'password'} placeholder="Repeat Password" name="confirm_password" value={formValues.confirm_password} onChange={handleInputChange} className={`form-control bg-transparent register-confirm_password-inp ${errors.confirm_password ? 'is-invalid' : ''}`} />
                        <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                          <i className={`bi bi-eye-slash fs-4 text-muted ${showPasswordRe ? 'd-none' : ''}`}
                            onClick={togglePasswordVisibilityRe}
                          ></i>
                          <i className={`bi bi-eye fs-4  text-primary ${showPasswordRe ? '' : 'd-none'}`}
                            onClick={togglePasswordVisibilityRe}
                          ></i>
                        </div>
                        {errors.confirm_password && <div className="text-danger">{errors.confirm_password}</div>}
                      </div>

                      {/* Checkbox input   */}
                      <div className="fv-row mb-8">
                        <label className="form-check form-check-inline">
                          <input className="form-check-input" type="checkbox" name="toc" checked={formValues.toc} onChange={handleInputChange}
                          />
                          <span className="form-check-label fw-semibold text-gray-700 fs-base ms-1">
                            I Accept the{" "}
                            <a href="#" className="ms-1 link-primary">
                              Terms
                            </a>
                          </span>
                        </label>
                        {errors.toc && <div className="text-danger">{errors.toc}</div>}
                      </div>
                      {/* <div className="fv-row mb-8 register-sale-acct" style={{ display: 'block', }}>
                        <label className="form-check form-check-inline form-switch form-switch-sm form-check-custom form-check-solid">
                          <input id="sale-register-account-exist" checked={alreadyHaveAccount}
                            onChange={toggleAccountCheckbox} name="toc" type="checkbox" className="form-check-input" style={{ cursor: 'pointer', height: '1.25rem' }} />
                          <span className="form-check-label fw-semibold text-gray-700 fs-base ms-1">Already have an Account </span>
                        </label>
                      </div> */}
                      {/* Submit Button */}
                      <div className="d-grid mb-10">
                        <div className="text-center fs-1x fw-bold text-primary">({details.discountedPrice}{details.discountedTimeperiod})</div>
                        <button
                          onClick={handleClickPlans}
                          className="btn btn-theme btn-shadow register-btn"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              {alreadyHaveAccount ? "Signing in..." : "Signing up..."}{' '}
                              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                          ) : (
                            `${alreadyHaveAccount ? "Sign In" : "Sign Up"}`
                          )}
                        </button>

                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="d-flex flex-column flex-lg-row flex-column-fluid" style={{ backgroundColor: '#F7F8FB' }}>
          {/* Left Column */}
          <div className="d-flex flex-lg-row-fluid">
            <div className="d-none d-md-flex flex-column flex-center pb-0 w-100">
              <img className="theme-light-show w-250px mx-auto pb-10" src={logo} alt="Logo" />
              <section className="HomeVideoSection">
                <div className="HomeVideoOuter">
                  <div className="video-wrapper">
                    <div className="wistia_responsive_padding" style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                      <div className="wistia_responsive_wrapper" style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
                        <iframe
                          src="https://fast.wistia.net/embed/iframe/dajig0c7nu?seo=true&videoFoam=true"
                          title="How Hey Visuals AI Works? Video"
                          allow="autoplay; fullscreen"
                          frameBorder="0"
                          scrolling="no"
                          className="wistia_embed"
                          name="wistia_embed"
                          style={{ width: '100%', height: '100%' }}
                        ></iframe>
                      </div>
                    </div>
                    <script src="https://fast.wistia.net/assets/external/E-v1.js" type="application/javascript" async></script>
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* Right Section */}
          <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-md-12 p-10">
            <div className="bg-body-md d-flex flex-column flex-center rounded-4 w-md-600px p-md-10">
              <div className="bg-body-sm d-flex flex-center flex-column align-items-stretch rounded-4 h-lg-100 w-md-400px p-md-0 p-7">
                <div className="d-flex flex-center flex-column flex-column-fluid">
                  <img className="d-md-none d-lg-none d-xl-none theme-light-show mb-3 w-75" src={logo} alt="Mobile Logo" />
                  {/* Form Section */}
                  <form method="POST" className="form w-100" id="register-form" noValidate onSubmit={handleSubmit}>
                    <div className="text-center mb-11">
                      <h1 className="text-dark fw-bolder mb-3">Sign Up</h1>
                      <div className="text-gray-500 fw-semibold fs-6 text-muted">
                        Your Social Campaigns
                      </div>
                    </div>
                    <div>
                      <GoogleSignInPage />
                    </div>
                    <div className="separator separator-content my-8">
                      <span className="w-125px text-gray-500 fw-semibold fs-7">Or with email</span>
                    </div>

                    {/* Name input   */}
                    <div className="fv-row mb-8">
                      <input type="text" placeholder="Name" name="name" value={formValues.name} onChange={handleInputChange} className={`form-control bg-transparent register-name-inp ${errors.name ? 'is-invalid' : ''}`} />
                      {errors.name && <div className="text-danger">{errors.name}</div>}
                    </div>

                    {/* email  */}
                    <div className="fv-row mb-8">
                      <input type="email" placeholder="Email" name="email" value={formValues.email} onChange={handleInputChange} className={`form-control bg-transparent register-email-inp ${errors.email ? 'is-invalid' : ''}`} />
                      {errors.email && <div className="text-danger">{errors.email}</div>}
                    </div>

                    {/* Phone number input   */}
                    <div className="fv-row mb-8">
                      <input
                        type="text"
                        placeholder="Phone (Optional)"
                        autoComplete="off"
                        name="phone_number"
                        value={formValues.phone_number}
                        onChange={handleInputChangephone}
                        className={`form-control bg-transparent register-phone_number-inp ${errors.email ? 'is-invalid' : ''}`}
                        maxLength="14"
                      />
                      <span className="col-md-12">
                        <em>eg:- (xxx) xxx-xxxx</em>
                      </span>
                      {errors.phone_number && <div className="text-danger">{errors.phone_number}</div>}
                    </div>

                    {/* Password input   */}
                    <div className="fv-row mb-8" data-kt-password-meter="true" style={{ position: 'relative' }}>
                      <input type={showPassword ? 'text' : 'password'} placeholder="Password" name="password" value={formValues.password} onChange={handleInputChange} className={`form-control bg-transparent register-password-inp ${errors.password ? 'is-invalid' : ''}`} />
                      <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                        <i className={`bi bi-eye-slash fs-4 text-muted ${showPassword ? 'd-none' : ''}`}
                          onClick={togglePasswordVisibility}
                        ></i>
                        <i className={`bi bi-eye fs-4  text-primary ${showPassword ? '' : 'd-none'}`}
                          onClick={togglePasswordVisibility}
                        ></i>
                      </div>
                      {errors.password && <div className="text-danger">{errors.password}</div>}
                      <p className="text-muted">Use 8 or more characters with a mix of letters, at least one capital letter, one number, and one special character.</p>
                    </div>

                    {/* Password Confirm input   */}
                    <div className="fv-row mb-8" style={{ position: 'relative' }}>
                      <input type={showPasswordRe ? 'text' : 'password'} placeholder="Repeat Password" name="confirm_password" value={formValues.confirm_password} onChange={handleInputChange} className={`form-control bg-transparent register-confirm_password-inp ${errors.confirm_password ? 'is-invalid' : ''}`} />
                      <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                        <i className={`bi bi-eye-slash fs-4 text-muted ${showPasswordRe ? 'd-none' : ''}`}
                          onClick={togglePasswordVisibilityRe}
                        ></i>
                        <i className={`bi bi-eye fs-4  text-primary ${showPasswordRe ? '' : 'd-none'}`}
                          onClick={togglePasswordVisibilityRe}
                        ></i>
                      </div>
                      {errors.confirm_password && <div className="text-danger">{errors.confirm_password}</div>}
                    </div>

                    {/* Checkbox input   */}
                    <div className="fv-row mb-8">
                      <label className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" name="toc" checked={formValues.toc} onChange={handleInputChange}
                        />
                        <span className="form-check-label fw-semibold text-gray-700 fs-base ms-1">
                          I Accept the{" "}
                          <a href="#" className="ms-1 link-primary">
                            Terms
                          </a>
                        </span>
                      </label>
                      {errors.toc && <div className="text-danger">{errors.toc}</div>}
                    </div>

                    {/* Submit Button */}
                    <div className="d-grid mb-10">
                      <button
                        type="submit"
                        className="btn btn-theme btn-shadow  register-btn"
                        disabled={loading || loadingGoogle || !isFormValid()}
                      >
                        {loading || loadingGoogle ? (
                          loadingGoogle ? (
                            <>
                              Please wait...{' '}
                              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                          ) : (
                            <>
                              Signing up...{' '}
                              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                          )
                        ) : (
                          'Sign up'
                        )}
                      </button>
                    </div>
                    <div className="text-gray-500 text-center fw-semibold fs-6">
                      Already have an Account?{" "}
                      <Link to="/login" className="link-primary fw-semibold">
                        Sign in
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RegisterPage;
